module.exports = __webpack_public_path__ + "static/img/4.c5625ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/4.png
// module id = s6Qd
// module chunks = 0